import { Layout } from 'antd';
import { LayoutProps } from 'antd/lib/layout';
import React from 'react';

const HeaderBase = Layout.Header;

export interface ILayoutProps extends LayoutProps {}

const Header: React.FC<ILayoutProps> = ({ children, ...props }) => {
  return <HeaderBase {...props}>{children}</HeaderBase>;
};

export default Header;
